<template>
    <article-show-page :article="article" v-model:permissions="authPermissions">
		<app-app-header v-model="indexStore.isHeaderVisible"
						:title="article.category.title"
						:to="$app('news', {query: {category: article.category._key}})"
						:breadcrumbs="[{text: article.type.title, to: $app('news')}]"
						:heading="false"
						:color="$config.public.colors.news">

            <client-only>
                <btn v-if="article.club && authPermissions.update" fab :to="`https://${article.club._key}.spoferan.com/articles/${article._key}/edit`" class="ml-12 sm:ml-16">
					<icon :icon="icons.edit"/>
				</btn>
            </client-only>
			<btn fab @click="indexStore.share({id: `article-${article._key}`})" class="ml-12 sm:ml-16">
				<icon :icon="icons.share"/>
			</btn>
        </app-app-header>
    </article-show-page>
</template>

<script setup lang="ts">
import {useIndexStore} from "../../store";
import {editIcon, shareIcon} from "@spoferan/nuxt-spoferan/icons";

const {$api, $web, $app, $auth, $image} = useNuxtApp();
const config = useRuntimeConfig();
const route = useRoute();
const indexStore = useIndexStore();
const {value: cacheBusterValue} = useCacheBuster('article_ts');

const {data} = await useApiFetch(`/v1/view/articles/${route.params.article}`, {
	guest: true,
	params: {
		ts: cacheBusterValue
	}
});

const article = data;

// Handle type redirects
if (article && article.type.value !== 'news') {
	await navigateTo(route.fullPath.replace('news', article.type.value), {
		redirectCode: 308
	});
}

// Handle slug redirects
if (article && article._key !== route.params.article) {
	await navigateTo({params: {article: article._key}}, {
		redirectCode: 308
	});
}

const authPermissions = ref({update: false});

const icons = {
	edit: editIcon,
	share: shareIcon,
};

const authors: {}[] = [];
if (article.club) {
	authors.push({
		'@type': 'Organization',
		'name': article.club.display_name,
		'url': $web('clubs.show', article.club._key, true),
		'logo': $image.format(article.club.avatar_thumbnail)
	});
}
if (article.author) {
	authors.push({
		'@type': 'Person',
		'name': article.author.display_name,
		'url': $web('users.show', article.author._key, true),
	});
}

useMeta({
	title: article.title,
	description: article.preview_text,
	type: 'article',
	image: $image.format(article.image),
	meta: [
		{
			'property': 'article:modified_time',
			'content': article.content_updated_at
		},
		{
			'property': 'article:published_time',
			'content': article.published_at
		},
		{
			'property': 'article:publisher',
			'content': 'https://www.facebook.com/spoferan'
		},
		{
			'property': 'article:section',
			'content': 'Sports'
		}
	],
	scripts: article.scripts,
});

useSchemaOrg([
	defineArticle({
		"@type": "NewsArticle",
		articleSection: "Sports",
		headline: article.title,
		description: article.preview_text,
		datePublished: article.published_at,
		dateModified: article.content_updated_at,
		author: authors,
		image: $image.format(article.image),
		mainEntityOfPage: $app('news-article', {params: {article: article._key}}, true),
		commentCount: article.comments_count,
		isAccessibleForFree: true
	}),
])

</script>

